import { Text, Heading, Img } from "./..";
import React from "react";

export default function LandingPageWIPFeature({
  image = "images/img_user.svg",
  title = "You share your story",
  description = "Start with your imagination. Upload a photo, describe your characters, and tell us what makes this story special to you.",
  ...props
}) {
  return (
    <div {...props} className={`${props.className} flex flex-col w-[32%] md:w-full gap-3.5`}>
      <Img src={image} alt="Image" className="h-[4vw] w-[fit-content] object-contain sm:h-[48px] sm:w-[48px]" />
      <div className="flex flex-col items-start self-stretch">
        <Heading size="text2xl" as="p" className="text-[1.1vw] font-medium !text-orange_accent1 sm:text-[20px] sm:leading-[24px]">
          {title}
        </Heading>
        <Text as="p" className="w-full md:text-[16px] text-[1vw] font-normal sm:text-[16px] sm:leading-[24px]">
          {description}
        </Text>
      </div>
    </div>
  );
}
